/**
 * https://open-meteo.com/en/docs
 * https://open-meteo.com/en/docs#latitude=-32.93&longitude=151.78&hourly=temperature_2m,relativehumidity_2m,apparent_temperature,precipitation_probability,weathercode&daily=weathercode,temperature_2m_max,temperature_2m_min,precipitation_hours,precipitation_probability_max&current_weather=true&timezone=Australia%2FSydney
 *  https://api.open-meteo.com/v1/forecast?latitude=-32.93&longitude=151.78&hourly=temperature_2m,relativehumidity_2m,apparent_temperature,precipitation_probability,weathercode&daily=weathercode,temperature_2m_max,temperature_2m_min,precipitation_hours,precipitation_probability_max&current_weather=true&timezone=Australia%2FSydney
 * 
 * 
 * WMO Weather interpretation codes (WW)
    Code	    Description
    0	        Clear sky // sun
    1, 2, 3	    Mainly clear, partly cloudy, and overcast // cloud-sun
    45, 48	    Fog and depositing rime fog // smog
    51, 53, 55	Drizzle: Light, moderate, and dense intensity // cloud-rain
    56, 57	    Freezing Drizzle: Light and dense intensity - icicles
    61, 63, 65	Rain: Slight, moderate and heavy intensity - cloud-showers-heavy
    66, 67	    Freezing Rain: Light and heavy intensity - snowflake
    71, 73, 75	Snow fall: Slight, moderate, and heavy intensity - snowflake
    77	        Snow grains - snowflake
    80, 81, 82	Rain showers: Slight, moderate, and violent - cloud-rain
    85, 86	    Snow showers slight and heavy - cloud-showers-heavy
    95 *	    Thunderstorm: Slight or moderate - cloud-bolt
    96, 99 *	Thunderstorm with slight and heavy hail - cloud-meatball
 */

let clear = { name: 'Clear sky', icon: 'sun' },
    mainlyClear = { name: 'Mainly clear', icon: 'cloud-sun'},
    partlyCloudy = { name: 'Partly cloudy', icon: 'cloud-sun'},
    overcast = { name: 'Overcast', icon: 'cloud'},
    fog = { name: 'Fog', icon: 'smog'},
    rime = { name: 'Depositing rime fog', icon: 'smog'},
    drizzleLight = { name: 'Light drizzle', icon: 'cloud-sun-rain'},
    drizzleModerate = { name: 'Moderate drizzle', icon: 'cloud-rain'},
    drizzleDense = { name: 'Dense drizzle', icon: 'cloud-showers-heavy'},
    freezingDrizzleLight = { name: 'Light freezing drizzle', icon: 'snowflake'},
    freezingDrizzleDense = { name: 'Dense freezing drizzle', icon: 'icicles'},
    rainSlight = { name: 'Slight rain', icon: 'cloud-sun-rain'},
    rainModerate = { name: 'Moderate rain', icon: 'cloud-rain'},
    rainHeavy = { name: 'Heavy rain', icon: 'cloud-showers-heavy'},
    freezingRainLight = { name: 'Light freezing rain', icon: 'cloud-rain'},
    freezingRainHeavy = { name: 'Heavy freezing rain', icon: 'cloud-showers-heavy'},
    snowSlight = { name: 'Slight snowfall', icon: 'snowflake'},
    snowModerate = { name: 'Moderate snowfall', icon: 'snowflake'},
    snowHeavy = { name: 'Heavy snowfall', icon: 'icicles'},
    snowGrains = { name: 'Snow grains!?', icon: 'icicles'},
    rainShowersSlight = { name: 'Slight rain', icon: 'cloud-sun-rain'},
    rainShowersModerate = { name: 'Moderate rain', icon: 'cloud-rain'},
    rainShowersHeavy = { name: 'Violent rain', icon: 'cloud-showers-heavy'},
    snowShowersSlight = { name: 'Slight snow showers', icon: 'snowflake'},
    snowShowersHeavy = { name: 'Heavy snow showers', icon: 'icicles'},
    stormHeavy = { name: 'Moderate Thunderstorm', icon: 'cloud-bolt'},
    hailSlight = { name: 'Slight Hailstorm', icon: 'cloud-meatball'},
    hailHeavy = { name: 'Heavy Hailstorm', icon: 'cloud-meatball'}

const WEATHERCODE_MAP = new Map([
    [0, clear],
    [1, mainlyClear],
    [2, partlyCloudy],
    [3, overcast],
    [45, fog],
    [48, rime],
    [51, drizzleLight],
    [53, drizzleModerate],
    [55, drizzleDense],
    [56, freezingDrizzleLight],
    [57, freezingDrizzleDense],
    [61, rainSlight],
    [63, rainModerate],
    [65, rainHeavy],
    [66, freezingRainLight],
    [67, freezingRainHeavy],
    [71, snowSlight],
    [73, snowModerate],
    [75, snowHeavy],
    [77, snowGrains],
    [80, rainShowersSlight],
    [81, rainShowersModerate],
    [82, rainShowersHeavy],
    [85, snowShowersSlight],
    [86, snowShowersHeavy],
    [95, stormHeavy],
    [96, hailSlight],
    [99, hailHeavy]
]);


export default WEATHERCODE_MAP